<div class="container-fluid p-0 d-lg-block d-none">
  <div class="head-background d-flex flex-column">
    @if (randomVideoUrl && !isMobile) {
      <video #videoElement
             autoplay
             loop
             muted
             playsinline
             preload="metadata"
             webkit-playsinline>
        <source [src]="randomVideoUrl"
                type="video/mp4">
      </video>
    }
    <div class="menu-bar d-flex align-items-center justify-content-between">
      <div>
        <ul>
          <li (click)="onBranchHomeClicked()">
            <a>{{ 'HomePage' | translate }}</a>
          </li>
          @if (authenticationService.hasAccount()) {
            <li (click)="onOrdersClicked()">
              <a>{{ 'Orders' | translate }}</a>
            </li>
          }
          <li (click)="onAboutUsClicked()">
            <a>{{ 'AboutUs' | translate }}</a>
          </li>
        </ul>
      </div>
      <div (click)="onHomeClicked()"
           class="nav d-flex align-items-center">
        <img class="ms-2"
             src="/icons/arrow-down-white.svg">
        <div class="d-flex flex-column align-items-center justify-content-center">
          <div>
            <span style="color: white">{{ Config.branch.Title }}</span>
          </div>
          <div>
            <span style="font-size: 12px;color: white">{{ Config.branch.Details.Address }}</span>
          </div>
        </div>
        <img src="/icons/rebelanLogo.png"
             style="width: 40px;height: 40px">
      </div>
      <div class="col-2 d-flex align-items-center justify-content-end"
           style="width:219px">
        @if (authenticationService.hasAccount()) {
          <!--          <mat-form-field class="mb-0 select-account">-->
          <app-frontend-button (click)="onProfileClicked()"
                               [Image]="true"
                               [class]="'card-red'"
                               [src]="'/icons/profile.svg'"
                               [title]="((Config.userInformation?.FirstName ?? '') + ' ' + (Config.userInformation?.LastName ?? ''))"></app-frontend-button>
          <!--            <mat-select panelClass="dropDown-seasons-panel btn-account">-->
            <!--              <mat-select-trigger>-->
            <!--                'انتخاب نمایید...-->
            <!--              </mat-select-trigger>-->
            <!--              <mat-option>-->
            <!--                     <span>-->
            <!--                      <img src="/icons/person.svg">-->
            <!--                       {{ 'IndividualProfile' | translate }}-->
            <!--                     </span>-->
            <!--              </mat-option>-->
            <!--              <hr>-->
            <!--              <mat-option>-->
            <!--                <span>-->
            <!--                  <img src="/icons/orders.svg">-->
            <!--                  {{ 'Orders' | translate }}-->
            <!--                </span>-->
            <!--              </mat-option>-->
            <!--              <hr>-->
            <!--              <mat-option>-->
            <!--                <span>-->
            <!--                  <img src="/icons/heart.svg">-->
            <!--                  {{ 'Favorites' | translate }}-->
            <!--                </span>-->
            <!--              </mat-option>-->
            <!--              <hr>-->
            <!--              <mat-option>-->
            <!--                <span>-->
            <!--                  <img src="/icons/address.svg">-->
            <!--                  {{ 'Addresses' | translate }}-->
            <!--                </span>-->
            <!--              </mat-option>-->
            <!--              @if (Config.userInformation?.UserType === 'STAFF') {-->
            <!--                <hr>-->
            <!--                <mat-option>-->
            <!--                <span>-->
            <!--                  <img src="/icons/info-circle-solid.svg">-->
            <!--                  {{ 'AdminPanel' | translate }}-->
            <!--                </span>-->
            <!--                </mat-option>-->
            <!--              }-->
            <!--            </mat-select>-->
            <!--          </mat-form-field>-->
        } @else {
          <app-frontend-button (click)="openLogin()"
                               [Image]="true"
                               [class]="'card-red'"
                               [src]="'/icons/login.svg'"
                               [title]="'LoginOrRegister'"></app-frontend-button>
        }
      </div>
    </div>
    <div class="flex-fill">
      <div class="welcome-box d-flex flex-column align-items-center justify-content-center">
        <div class="d-flex justify-content-center align-items-center mb-4">
          <app-frontend-button [Image]="true"
                               [class]="'card-red'"
                               [src]="'/icons/circleIcon.svg'"
                               [title]="Config.branch.Details?.ActiveOrdering ? 'WeAcceptOrders' : 'NotActiveOrdering'"></app-frontend-button>
        </div>
        <img class="mb-2"
             src="/icons/line.svg">
        <span>{{ 'Welcome' | translate }}</span>
      </div>
      <div class="d-flex justify-content-center">
        <img
          [ngStyle]="{ 'background': Config.branch.Details?.LogoBackgroundColor || '','opacity': Config.branch.Details?.LogoBackgroundOpacity || 1}"
          [src]="formatImage('', Config.branch.Details.LogoFont)"
          alt="branch-logo"
          style="padding: 8px;margin-bottom: 24px;"
          width="400">
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <app-frontend-button (click)="onMenuClicked()"
                             [Image]="true"
                             [class]="'card-light'"
                             [src]="'/icons/menu-footer.svg'"
                             [title]="'ShowMenu'"></app-frontend-button>
      </div>
    </div>
  </div>
</div>
<!--********************************mobile-header-->
<nav (click)="onHomeClicked()"
     class="navbar d-flex align-items-center justify-content-center d-lg-none d-block">
  <img class="ms-2"
       src="/icons/arrow-down.svg">
  <div class="d-flex flex-column align-items-center justify-content-center">
    <div>
      <span>{{ Config.branch.Title }}</span>
    </div>
    <div>
      {{ Config.branch.Details.Address }}
    </div>
    @if (!Config.branch.Details?.ActiveOrdering) {
      <div>
        {{ 'NotActiveOrdering' | translate }}
      </div>
    }
  </div>
  <img src="/icons/rebelanLogo.png"
       style="width: 40px;height: 40px">
</nav>
